import { http } from './http2';
import { getUrlParams } from '@/utils';
const isDev = process.env.NODE_ENV === 'development';
const devBaseUrl = '/mixServer';
let currentUrl = getUrlParams('mix_url') ? 'https://' + getUrlParams('mix_url') : 'http://api.sdk.leniugame.com'
const prodBaseUrl = location.host === 'apisdk.lnqwe.com' ? 'https://apisdk2.lnqwe.com' : currentUrl;

export const mainTaskApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/game/clientEvent',
    type: 'post',
    params
  });
};
export const nirvanaApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/game/clientEvent ',
    type: 'post',
    params
  });
};
export const createPageApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/roleCreatePage',
    type: 'post',
    params
  });
};
export const initializeApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/app/initialize',
    type: 'post',
    params
  });
};
export const selectServerApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/selectServer',
    type: 'post',
    params
  });
};
export const finishServerApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/finishServer',
    type: 'post',
    params
  });
};
export const certApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/cert',
    type: 'post',
    params
  });
};
export const enterGameApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/enterGame',
    type: 'post',
    params
  });
};
export const roleReportApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/game/clientEvent',
    type: 'post',
    params
  });
};
export const onlineApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/online',
    type: 'post',
    params
  });
};
export const lnsdkLoginApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/lnsdkLogin ',
    type: 'post',
    params
  });
};
export const fushionLoginApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/fusion/login',
    type: 'post',
    params
  });
};
export const activateApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/app/activate',
    type: 'post',
    params
  });
};
export const clearCacheApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/user/cleanCache',
    type: 'post',
    params
  });
};
export const gameLoadApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/xcxGame/clientEvent',
    type: 'post',
    params
  });
};
export const clientEventApi = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/game/clientEvent',
    type: 'post',
    params
  });
};

// 广告拉取
export const adReportReq = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/iaa/adReq',
    type: 'post',
    params
  });
};
// 广告曝光
export const adReportExposure = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/iaa/adExposure',
    type: 'post',
    params
  });
};
// 广告完播
export const adReportWatch = (params, event) => {
  params.event = event;
  return http({
    url: '/stat/iaa/adWatch',
    type: 'post',
    params
  });
};